import resetPasswordService from '../resetPassword/ResetPasswordService';
import serviceAccountService from './service/ServiceAccountService';
import customerService from '../customer/CustomerService';
import {
  FIRST_TIME_SETUP_GET_PASSWORD_REQUEST,
  FIRST_TIME_SETUP_GET_PASSWORD_SUCCESS,
  FIRST_TIME_SETUP_GET_PASSWORD_FAILURE,
  FIRST_TIME_SETUP_DEFINE_PASSWORD_REQUEST,
  FIRST_TIME_SETUP_DEFINE_PASSWORD_SUCCESS,
  FIRST_TIME_SETUP_DEFINE_PASSWORD_FAILURE,
  FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_REQUEST,
  FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_SUCCESS,
  FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_FAILURE,
  FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_REQUEST,
  FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_SUCCESS,
  FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_FAILURE,
} from './FirstTimeSetupActionType';

export const loadDvrToolkitData = () => async (dispatch) => {
  dispatch({ type: FIRST_TIME_SETUP_GET_PASSWORD_REQUEST });
  try {
    const installData = await resetPasswordService.search();
    dispatch({
      type: FIRST_TIME_SETUP_GET_PASSWORD_SUCCESS,
      payload: installData.data,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    dispatch({ type: FIRST_TIME_SETUP_GET_PASSWORD_FAILURE });
  }
};

export const defineDvrToolkitPassword = (userName, password) => async (
  dispatch,
) => {
  dispatch({ type: FIRST_TIME_SETUP_DEFINE_PASSWORD_REQUEST });

  try {
    const passwordPromise = resetPasswordService.post({
      userName,
      password,
    });

    const customerPromise = customerService.updateName();

    await Promise.all([passwordPromise, customerPromise]);

    dispatch({ type: FIRST_TIME_SETUP_DEFINE_PASSWORD_SUCCESS });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    dispatch({ type: FIRST_TIME_SETUP_DEFINE_PASSWORD_FAILURE });
    throw e;
  }
};

export const createServiceAccount = () => async (dispatch) => {
  dispatch({ type: FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_REQUEST });

  try {
    await serviceAccountService.create();

    dispatch({ type: FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_SUCCESS });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    dispatch({ type: FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_FAILURE });
    throw e;
  }
};

export const skipServiceAccount = () => async (dispatch) => {
  dispatch({ type: FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_REQUEST });

  try {
    await serviceAccountService.skip();

    dispatch({ type: FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_SUCCESS });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    dispatch({ type: FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_FAILURE });
    throw e;
  }
};
